module.exports = __webpack_public_path__ + "static/img/totoboLoader.85c0e64.gif";


//////////////////
// WEBPACK FOOTER
// ./static/assets/img/totoboLoader.gif
// module id = 44V8
// module chunks = 0